import React from 'react';

import {withCssModule} from '@pb/kit-util-with-css-module';

import styles from './loading.component.module.styl';

import type {ReactNode} from 'react';


const classNames = withCssModule(styles);

export type HolderProps = {
    /**
     * When `true`, applies `loading-wrapper` CSS semantics instead of the default
     * `loading-holder`. Wrappers typically span 100% width and act as a full
     * overlay container, while holders are inline-block placeholders that match
     * the spinner's intrinsic size. Defaults to `false`.
     */
    isWrapper?: boolean,

    /**
     * Explicit height in pixels applied as an inline `style`. Use this to
     * reserve a specific vertical space so the surrounding layout does not
     * shift when the spinner appears or disappears. When omitted, the holder
     * sizes itself to the spinner's natural height.
     */
    height?: number,

    /**
     * Custom classes
     * @deprecated It will be removed in 6 months 09-20-2025. use className instead
     */
    mix?: string,

    /**
     * LoadingHolder children
     * */
    children: ReactNode,

    /**
     * ClassName for the component
     */
    className?: string,
};

/**
 * Layout container that reserves space for a `Loading` spinner and prevents
 * content shift while data is being fetched.
 *
 * Renders a `<span>` with either `loading-holder` (default) or
 * `loading-wrapper` semantics depending on `isWrapper`. Accepts an optional
 * `height` in pixels to control the reserved area size. Place `Loading` inside
 * as a child.
 *
 * @see [Storybook]{@link https://storybook.dev.pitchbookdata.com/?path=/story/components-loading-loading}
 */
export function LoadingHolder(props: HolderProps) {
    const {
        isWrapper = false,
        height,
        mix,
        className,
        children,
    } = props;
    const loadingClasses = classNames(mix, className, {
        'loading-holder': !isWrapper,
        'loading-wrapper': isWrapper,
    });
    return (
        <span
            className={loadingClasses}

            style={
                height
                    ? {
                            height: `${height}px`,
                        }
                    : undefined
            }>
            {children}
        </span>
    );
}
